import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Modal, Button } from "react-bootstrap";
import styled from "styled-components";

import { validatePassword } from "_helpers";

import { ReactComponent as HideIcon } from "assets/img/Hide.svg";
import { ReactComponent as ShowIcon } from "assets/img/Show.svg";
import PasswordValidation from "widget/PasswordValidation";

const Group = styled(Form.Group)`
  margin-bottom: 1rem;
`;
const InputContainer = styled.div`
  position: relative;
  width: 100%;

  & input {
    padding-right: 48px !important;

    &.is-invalid {
      padding-right: 68px !important;
      background-position: right calc(0.375em + 0.1875rem + 30px) center;
    }
  }
`;

const ViewButton = styled.button`
  position: absolute;
  box-sizing: border-box;
  top: 3px;
  bottom: 0px;
  right: 8px;
  height: 30px;
  width: 30px;
  padding: 0px;
  border: none;
  background: transparent;
  color: #f37217;
  text-decoration: underline;
  font-size: 0.875rem;

  & svg {
    width: 100%;
    height: 100%;
  }
`;

const initPasswords = { "current-password": "", "new-password": "", "confirm-password": "" };
const initShow = { "current-password": false, "new-password": false, "confirm-password": false };

export function ChangePassword({ onConfirm, onCancel }) {
  const [beforeSubmit, setBeforeSubmit] = useState(true);
  const [passwords, setPasswords] = useState({ ...initPasswords });
  const [show, setShow] = useState({ ...initShow });

  // const passwordRegex = new RegExp(/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])(?!.*[ ]).{8,}$/);
  const isPasswordValid = validatePassword(passwords["new-password"]);

  const handleShowPassword = (name) => {
    setShow({ ...show, [name]: !show[name] });
  };

  const handleChangePassword = ({ target: { name, value } }) => {
    setPasswords({ ...passwords, [name]: value });
  };

  const handleSubmit = (event) => {
    setBeforeSubmit(false);
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (
      !(
        form.checkValidity() === false ||
        !isPasswordValid ||
        passwords["new-password"] !== passwords["confirm-password"]
      )
    ) {
      onConfirm(passwords["current-password"], passwords["new-password"]);
    }
  };

  return (
    <Modal centered show onHide={onCancel} size="md">
      <Modal.Header style={{ border: 0 }} />
      <Form noValidate validated={false} onSubmit={handleSubmit}>
        <Modal.Body>
          <Group controlId="formBasicCurrentPassword">
            <Form.Label>Current Password</Form.Label>
            <InputContainer>
              <Form.Control
                required
                type={show["current-password"] ? "text" : "password"}
                placeholder="Password"
                name="current-password"
                value={passwords["current-password"]}
                onChange={handleChangePassword}
                isInvalid={!beforeSubmit && !passwords["current-password"]}
              />
              <ViewButton type="button" name="current-password" onClick={() => handleShowPassword("current-password")}>
                {show["current-password"] ? <HideIcon className="icon" /> : <ShowIcon className="icon" />}
              </ViewButton>
              <Form.Control.Feedback type="invalid">Password invalid!</Form.Control.Feedback>
            </InputContainer>
          </Group>

          <Group controlId="formBasicNewPassword">
            <Form.Label>New Password</Form.Label>
            <InputContainer>
              <Form.Control
                required
                type={show["new-password"] ? "text" : "password"}
                placeholder="Password"
                name="new-password"
                value={passwords["new-password"]}
                onChange={handleChangePassword}
                isInvalid={!beforeSubmit && !isPasswordValid}
              />
              <ViewButton type="button" name="new-password" onClick={() => handleShowPassword("new-password")}>
                {show["new-password"] ? <HideIcon className="icon" /> : <ShowIcon className="icon" />}
              </ViewButton>
              <Form.Control.Feedback type="invalid">
                <PasswordValidation password={passwords["new-password"]} />
              </Form.Control.Feedback>
            </InputContainer>
          </Group>

          <Group controlId="formBasicConfirmPassword">
            <Form.Label>Confirm Password</Form.Label>
            <InputContainer>
              <Form.Control
                required
                type={show["confirm-password"] ? "text" : "password"}
                placeholder="Password"
                name="confirm-password"
                value={passwords["confirm-password"]}
                onChange={handleChangePassword}
                isInvalid={!beforeSubmit && passwords["new-password"] !== passwords["confirm-password"]}
              />
              <ViewButton type="button" name="confirm-password" onClick={() => handleShowPassword("confirm-password")}>
                {show["confirm-password"] ? <HideIcon className="icon" /> : <ShowIcon className="icon" />}
              </ViewButton>
              <Form.Control.Feedback type="invalid">Passwords is not equal!</Form.Control.Feedback>
            </InputContainer>
          </Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="warning" type="button" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="success" type="submit">
            Update
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

ChangePassword.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};
